import ParentLayout from '@/layouts/ParentLayout.vue';

const parentRoutes = [
  {
    path: '/parent',
    component: ParentLayout,
    meta: { 
      requiresAuth: true,
      role: 'parent'
    },
    children: [
      {
        path: '',
        name: 'ParentHome',
        component: () => import('@/views/parent/Home.vue'),
        meta: { title: '家长首页' }
      },
      {
        path: 'messages',
        name: 'ParentMessages',
        component: () => import('@/views/parent/Messages.vue'),
        meta: { title: '家校通知' }
      },
      {
        path: 'assignments',
        name: 'ParentAssignments',
        component: () => import('@/views/parent/Assignments.vue'),
        meta: { title: '作业查看' }
      },
      {
        path: 'scores',
        name: 'ParentScores',
        component: () => import('@/views/parent/Scores.vue'),
        meta: { title: '成绩查询' }
      },
      {
        path: 'communication',
        name: 'ParentCommunication',
        component: () => import('@/views/parent/Communication.vue'),
        meta: { title: '老师沟通' }
      },
      {
        path: 'courses',
        name: 'ParentCourses',
        component: () => import('@/views/parent/Courses.vue'),
        meta: { title: '预约课程' }
      },
      {
        path: 'activities',
        name: 'ParentActivities',
        component: () => import('@/views/parent/Activities.vue'),
        meta: { title: '活动查看' }
      }
    ]
  }
];

export default parentRoutes; 